import { createStore } from "vuex";
import { request } from "@/axios";
import { User } from "@/axios/interfaces/user";
import { Service } from "@/axios/interfaces/service";
import Bus from "@/utils/bus";
import { General } from "@/types/general";

const user: User.Instance = {
  appkey: "",
  identityType: undefined,
  id: 0,
  pin: "",
  stockUser: "0",
};

export default createStore({
  state: {
    identityDialogVisible: false,
    userInfo: user,
    services: [] as Service.Instance[],
    guideDialogVisible: false,
    identityType: null as User.IdentityEnumKey | null | undefined,
  },
  getters: {
    getUserServicesOptions(state): General.Option[] {
      return state.services.map((item: Service.Instance) => ({
        label: item.serviceName,
        value: item.appkey,
      }));
    },
  },
  mutations: {
    // 设置用户信息
    setUserInfo(state, user: User.Instance) {
      state.userInfo = user;
      if (user.identityType !== undefined && user.identityType !== null) {
        Bus.emit("choose-last-identity", user.identityType);
      }
      state.identityType = user.identityType;
    },
    setIdentity(state, newIdentity) {
      state.identityType = newIdentity;
      if (newIdentity !== undefined && newIdentity !== null) {
        Bus.emit("choose-last-identity", newIdentity);
      }
    },
    setUserAppKey(state, appkey: string) {
      state.userInfo.appkey = appkey;
      Bus.emit("refresh-list");
      Bus.emit("back-list");
    },
    setUserServiceName(state, serviceName: string) {
      state.userInfo.serviceName = serviceName;
      Bus.emit("refresh-list");
      Bus.emit("back-list");
    },
    setUserIdentity(state, identity: User.IdentityEnumKey) {
      state.userInfo.identityType = identity;
      Bus.emit("refresh-list");
      Bus.emit("back-list");
    },
    // 设置身份认证弹窗是否可见
    setIdentityDialogVisible(state, visible: boolean) {
      if (visible) {
        if (state.userInfo) {
          state.userInfo.identityType = undefined;
        }
      }
      state.identityDialogVisible = visible;
    },
    // 设置用户服务列表
    setUserServices(state, services: Service.Instance[]) {
      state.services = services;
    },
    setGuideDialogVisible(state, visible: boolean) {
      state.guideDialogVisible = visible;
    },
  },
  actions: {
    // 查询用户信息
    getUserInfo(store) {
      request.userIdentityInfo().then((response) => {
        const user = response.data;
        if (user.identityType === undefined || user.identityType === null) {
          store.commit("setIdentityDialogVisible", true);
        }
        store.commit("setUserInfo", user);
      });
    },
    //订阅服务列表
    getServiceList(store) {
      request.serviceList().then((response) => {
        const services = response.data || [];
        store.commit("setUserServices", services);
      });
    },
  },
  modules: {},
});
